<template>
  <div class="app-container">
    <list ref="list" :can-price="canPrice">
      <template slot="toolbar-right" v-if="canWrite">
        <el-button type="primary" @click="onShiftInventory" icon="el-icon-plus">转入库单</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button v-if="canWrite && row.Status !== 2" @click="edit(row)" type="text">编辑</el-button>
            <el-button v-if="canReview && row.Status == 2" type="text" @click="edit(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/pdaproductionshipping/list'


export default {
  name: "bom",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/stock/stInDocLog").default,

    }
  },
  computed: {
    canWrite() {
      return this.$permission.canWrite();
    },
    canPrice() {
      return this.$permission.canPrice();
    },
    canReview() {
      return this.$permission.canReview();
    },
  },
  methods: {
    edit(row) {
      
      let id = row.DocId;
      this.api.info(id).then(res => {
        if (res.Code === 0) {
          this.toURL({ name: 'editpdaproductionshipping', params: { type: 'edit', data: res.Data } })
        }
      })
    },
    toURL(o) {
      this.$router.push(o)
    },
    onShiftInventory() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要转入库单的数据");
        return;
      }
      this.$confirm("确认转入库单所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.DocId);
        this.$refs.list.shiftInventory(ids);
      }).catch(() => { });
    }
  }
};
</script>